<BuilderNavbar class="z-10"></BuilderNavbar><div class="height-view"><router-view></router-view></div>